import { Api } from '@axiom/ui';
import type { LimitedCandidate } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class LimitedCandidateApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async readLimitedCandidate(id: string) {
    return super.write<{ data: LimitedCandidate }>({
      endpoint: `/limitedCandidates/${id}`,
      method: 'GET',
    });
  }
}

export const LimitedCandidatesApi = new LimitedCandidateApiClass();
